var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { duration: 300 } }, [
    _vm.updateFields_Len > 0
      ? _c(
          "div",
          { staticClass: "TicketFormOperationBar" },
          [
            _vm.spanShow
              ? _vm._l(_vm.updateFields, function(v, k) {
                  return _c(
                    "div",
                    {
                      key: k,
                      staticStyle: {
                        margin: "0 10px 0 10px",
                        "font-size": "50%"
                      }
                    },
                    [
                      _c("span", [_vm._v(_vm._s(v.fieldLabel) + " : ")]),
                      _vm._v(" "),
                      _c(
                        "el-popover",
                        {
                          attrs: {
                            trigger: "hover",
                            placement: "top",
                            width: "950"
                          }
                        },
                        [
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(_vm.parsedFieldValueBefore(v))
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            { attrs: { slot: "reference" }, slot: "reference" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm._f("ellipsis_50")(
                                    _vm.parsedFieldValueBefore(v)
                                  )
                                )
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("span", [_vm._v(" > ")]),
                      _vm._v(" "),
                      _c(
                        "el-popover",
                        {
                          attrs: {
                            trigger: "hover",
                            placement: "top",
                            width: "950"
                          }
                        },
                        [
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(_vm.parsedFieldValue(v))
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            { attrs: { slot: "reference" }, slot: "reference" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm._f("ellipsis_50")(_vm.parsedFieldValue(v))
                                )
                              )
                            ]
                          )
                        ]
                      )
                    ],
                    1
                  )
                })
              : _vm._e(),
            _vm._v(" "),
            _c(
              "el-button",
              {
                attrs: { title: "点击提交修改", type: "primary" },
                on: { click: _vm.updateTicketFormField }
              },
              [_vm._v("提交修改")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              { attrs: { title: "点击取消" }, on: { click: _vm.doCancel } },
              [_vm._v("取消")]
            )
          ],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ff6c65f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ff6c65f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ticket/TicketFormOperationBar.vue
// module id = 840
// module chunks = 75